import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './styles/theme';
import App from './App';
import { NotificacionProvider } from './componentes/common/NotificacionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NotificacionProvider>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  </NotificacionProvider>
);

